<!--Deve atender todos os forms necessários para P&C -->
<template>
  <!--Dados do Sinistro -->
  <!--Bens Danificados -->
  <!--Dados de Vistoria -->
  <!-- Dados de Equipamento (apenas RD Equipamentos)-->

  <div v-if="objDTO !== null && currentAvisoId != 0">
    <div v-show="stage === 1">
      <dados-sinistro
        :validation="$v"
        :events="events"
        :isLoadingEvents="events.length == 0"
        :showCountrySelector="!isEquipmentForm"
      >
        <template #dadosCoberturas>
          <dados-coberturas-eventos
            v-if="!loading.apoliceData"
            :coverages="coverages"
            :events="events"
            :validation="$v"
            :insuranceObjects="insuranceObjects"
            :riskUnits="riskUnits"
            @coverageChange="handleCoverageChange"
            @riskUnitChange="handleRiskUnitChange"
            @insuranceObjectChange="handleInsuranceObjectChange"
          />
          <loading-state-f-s v-else />
        </template>
      </dados-sinistro>

      <bens-danificados
        :showEstimativaPrejuizo="!isEquipmentForm"
        :validation="$v"
      ></bens-danificados>
      <dados-terceiros v-if="!isEquipmentForm"></dados-terceiros>
      <dados-vistoria v-on:replicarVistoria="replicarVistoria" :validation="$v"></dados-vistoria>
      <dados-equipamento
        v-if="isEquipmentForm"
        :validation="$v"
      ></dados-equipamento>

      <div class="container" v-if="!$v.objDTO.$invalid">
        <div class="col-12 Aligner aligner-right mt-4">
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="stage = 2"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>
    <div v-if="stage === 2">
      <resume-property-casualty
        :coverages="coverages"
        :events="events"
        :riskUnits="riskUnits"
        :insuranceObjects="insuranceObjects"
        :objDTO="objDTO"
        :showEquipmentData="isEquipmentForm"
        @back="(v) => (stage = v)"
      ></resume-property-casualty>
    </div>
  </div>
  <loading-state-f-s v-else />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {
  getCoverages,
  getEvents,
  getEventsByProductId,
  getFormDataByApoliceProdutoIdAndBranchId,
  getInsuranceObjects,
} from '../api/formMethods';
import BensDanificados from '../components/areaNegocio/propertyCasualty/BensDanificados.vue';
import DadosEquipamento from '../components/areaNegocio/propertyCasualty/DadosEquipamento.vue';
import DadosSinistro from '../components/areaNegocio/propertyCasualty/DadosSinistro.vue';
import DadosTerceiros from '../components/areaNegocio/propertyCasualty/DadosTerceiros.vue';
import DadosVistoria from '../components/areaNegocio/propertyCasualty/DadosVistoria.vue';
import DadosCoberturasEventos from '../components/DadosCoberturasEventos.vue';
import ResumePropertyCasualty from '../components/Resume/ResumePropertyCasualty.vue';
import { FORMS } from '../utils/constants';
import { getInfoByOperationPK } from '../utils/helpers';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { dateAfterToday, inputClean } from '../utils/customValidations';
import LoadingStateFS from '../components/LoadingStateFS.vue';
import Swal from 'sweetalert2';

export default {
  components: {
    DadosTerceiros,
    DadosSinistro,
    BensDanificados,
    DadosVistoria,
    DadosEquipamento,
    ResumePropertyCasualty,
    DadosCoberturasEventos,
    LoadingStateFS,
  },
  data() {
    return {
      loading: {
        apoliceData: false,
      },
      events: [],
      riskUnits: [],
      insuranceObjects: [],
      coverages: [],
      isEquipmentForm: false,
      currentAvisoId: 0,
      formName: 'Aviso de Sinistro',
      stage: 1,
      brasilPaisId: 3,
    };
  },
  computed: {
    ...mapGetters({ objDTO: 'getObjDTO' }),
    isBrasilSinistroSelected() {
      console.log('pais id sinistro', this.objDTO.Sinistro.SinistroPaisId);
      return this.objDTO.Sinistro.SinistroPaisId === this.brasilPaisId;
    },
    isBrasilVistoriaSelected() {
      console.log(
        'pais id vistoria',
        this.objDTO.Vistoria.VistoriaLocal.PaisId
      );
      return this.objDTO.Vistoria.VistoriaLocal.PaisId === this.brasilPaisId;
    },
  },
  async mounted() {
    console.log('mounted');
    if (!this.objDTO) {
      this.$router.push({ name: 'Home' });
      return;
    }

    this.objDTO.Veiculo.ValorEstimadoReparacao =
      this.objDTO.Veiculo.ValorEstimadoReparacao ?? 0;
    //policy: "02852.2016.0001.0167.0000318"
    // this.objDTO.Apolice.ApoliceProdutoId = 105;
    // this.objDTO.Sinistro.SinistroRamoId = 67;
    // this.objDTO.Apolice.ApoliceContrato = 4655161847;

    // Load countries and states from API if not already loaded
    this.getOrSetCountries();
    this.getOrSetStatesBrasil();
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);

    if (!this.currentAvisoId) {
      Swal.fire({
        title: 'Erro',
        text: 'Não foi possível obter o formulário de aviso',
        icon: 'error',
        confirmButtonText: 'Ok',
      });

      this.$router.push({ name: 'Home' });
      return;
    }
  },
  validations() {
    const baseObj = {
      objDTO: {
        Veiculo: {
          Obs: { required },
        },
        Apolice: {
          ApoliceCoberturaId: { required },
          UnidadeDeRiscoExternalId: { required },
          ObjectoSeguradoExternalId: { required },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },
          SinistroEventoId: { required },
          SinistroDescricao: { required },
          SinistroMorada: {
            required,
            inputClean,
          },
          SinistroMoradaNrPorta: { required },
          SinistroPaisId: {
            requiredIf: requiredIf(() => !this.isEquipmentForm),
          },
          SinistroPaisDescricao: {
            requiredIf: requiredIf(() => !this.isEquipmentForm),
          },
          SinistroDistritoId: {
            requiredIf: requiredIf(() => this.isBrasilSinistroSelected),
          },
          SinistroDistritoDescripton: { required, inputClean },
          SinistroConcelhoId: {
            requiredIf: requiredIf(
              () =>
                this.isBrasilSinistroSelected &&
                this.objDTO.Sinistro.SinistroDistritoId
            ),
          },
          SinistroConcelhoDescription: { required, inputClean },
          SinistroFreguesiaId: {
            requiredIf: requiredIf(
              () =>
                this.isBrasilSinistroSelected &&
                this.objDTO.Sinistro.SinistroConcelhoId
            ),
          },
          SinistroFreguesiaDescription: { required, inputClean },
        },
        Vistoria: {
          VistoriaLocal: {
            Telemovel: { required },
            Nome: { required },
            Morada: { required },
            CodPostalLocalidade: { required },
            PaisId: { required },
            PaisDescription: { required },
            DistritoId: {
              requiredIf: requiredIf(() => this.isBrasilVistoriaSelected),
            },
            DistritoDescription: {
              requiredIf: requiredIf(() => this.isBrasilVistoriaSelected),
            },
            ConcelhoId: {
              requiredIf: requiredIf(
                () =>
                  this.isBrasilVistoriaSelected &&
                  this.objDTO.Vistoria.VistoriaLocal.DistritoId
              ),
            },
            ConcelhoDescription: {
              requiredIf: requiredIf(
                () =>
                  this.isBrasilVistoriaSelected ||
                  this.isEquipmentForm ||
                  this.objDTO.Vistoria.VistoriaLocal.DistritoDescription
              ),
            },
            FreguesiaId: {
              requiredIf: requiredIf(
                () =>
                  this.isBrasilVistoriaSelected &&
                  this.objDTO.Vistoria.VistoriaLocal.ConcelhoId
              ),
            },
            FreguesiaDescription: {
              requiredIf: requiredIf(
                () =>
                  this.isBrasilVistoriaSelected ||
                  this.isEquipmentForm ||
                  this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription
              ),
            },
          },
        },
      },
    };

    if (this.isEquipmentForm) {
      baseObj.objDTO.Veiculo = {
        ...baseObj.objDTO.Veiculo,
        Modelo: { required },
        ModeloAno: { required },
        NrChassis: { required },
      };

      baseObj.objDTO.ProcessoGDM = {
        Marca: { required },
        Modelo: { required },
      };
    }

    return baseObj;
  },
  methods: {
    ...mapMutations(['setLocalVistoria']),
    ...mapActions(['getOrSetCountries', 'getOrSetStatesBrasil']),
    replicarVistoria(){
      this.setLocalVistoria({
        Morada: 'Teste',
      });

      this.$forceUpdate();
      // this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade =
      //   locationObject.number;
      // this.objDTO.Vistoria.VistoriaLocal.PaisId = locationObject.countryId;
      // this.objDTO.Vistoria.VistoriaLocal.PaisDescription =
      //   locationObject.countryDescription;
      // this.objDTO.Vistoria.VistoriaLocal.DistritoId = locationObject.stateId;
      // this.objDTO.Vistoria.VistoriaLocal.DistritoDescription =
      //   locationObject.stateDescription;
      // this.objDTO.Vistoria.VistoriaLocal.ConcelhoId = locationObject.cityId;
      // this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription =
      //   locationObject.cityDescription;
      // this.objDTO.Vistoria.VistoriaLocal.FreguesiaId =
      //   locationObject.localityId;
      // this.objDTO.Vistoria.VistoriaLocal.FreguesiaDescription =
      //   locationObject.localityDescription;
      // this.objDTO.Vistoria.VistoriaLocal.Obs = locationObject.complement;
    },
    async handleRiskUnitChange() {
      this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
      this.objDTO.Apolice.ApoliceCoberturaId = null;
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.insuranceObjects = [];
      this.coverages = [];
      this.events = [];

      if (this.objDTO.Apolice.UnidadeDeRiscoExternalId) {
        this.insuranceObjects = await getInsuranceObjects(
          this.objDTO.Apolice.ApoliceContrato,
          this.objDTO.Apolice.UnidadeDeRiscoExternalId
        );

        if (this.insuranceObjects && this.insuranceObjects.length == 1) {
          const object = this.insuranceObjects[0];

          this.objDTO.Apolice.ObjectoSeguradoExternalId =
            object.InsuranceObjectId;

          this.handleInsuranceObjectChange();
        }
      }
    },
    async handleInsuranceObjectChange() {
      this.objDTO.Apolice.ApoliceCoberturaId = null;
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.coverages = [];
      this.events = [];

      if (this.objDTO.Apolice.ObjectoSeguradoExternalId) {
        this.coverages = await getCoverages(
          this.objDTO.Apolice.ApoliceContrato,
          this.objDTO.Apolice.ObjectoSeguradoExternalId
        );
      }
    },
    async handleCoverageChange() {
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.events = [];
      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );

      if (!this.events || this.events.length == 0) {
        const eventsByProductId = await getEventsByProductId(
          this.objDTO.Apolice.ApoliceProdutoId
        );
        this.events = eventsByProductId;
      }
    },
    async policySelected(operationPK) {
      if (operationPK) {
        window.scrollTo(0, 0);

        const formData = await getFormDataByApoliceProdutoIdAndBranchId(
          this.objDTO.Apolice.ApoliceProdutoId,
          this.objDTO.Apolice.ApoliceCoberturaId
        );

        console.log(
          `Form Data: ApoliceProdutoId ${this.objDTO.Apolice.ApoliceProdutoId}`,
          formData
        );

        const formAvisoId = formData.Id;
        this.currentAvisoId = formAvisoId;
        this.formName = formData.Description;
        this.objDTO.FormAvisoId = formAvisoId;
        this.isEquipmentForm = formAvisoId === FORMS.RDEquipamentos;

        console.log('Is Equipment Form: ', this.isEquipmentForm);

        try {
          this.loading.apoliceData = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          if (!events || events.length == 0) {
            const eventsByProductId = await getEventsByProductId(
              this.objDTO.Apolice.ApoliceProdutoId
            );
            this.events = eventsByProductId;
          } else {
            this.events = events;
          }

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = riskUnits;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;

          console.log('events', this.events);
          console.log('riskUnits', this.riskUnits);
          console.log('insuranceObjects', this.insuranceObjects);
          console.log('coverages', this.coverages);
          console.log(
            'Unidade de Risco: ',
            this.objDTO.Apolice.UnidadeDeRiscoExternalId
          );
          console.log(
            'Objecto Segurado: ',
            this.objDTO.Apolice.ObjectoSeguradoExternalId
          );
          console.log('Cobertura: ', this.objDTO.Apolice.ApoliceCoberturaId);
        } catch (error) {
          console.error(error);
        } finally {
          this.loading.apoliceData = false;
        }
      }
    },
  },
};
</script>

<style>
.textAlignCenter {
  text-align: center;
}
</style>
